<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import ButtonGroup from 'dashboard/components-next/buttonGroup/ButtonGroup.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { computed } from 'vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { useMapGetter } from 'dashboard/composables/store';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';

defineProps({
  rail: {
    type: Boolean,
    default: false,
  },
});

const { updateUISettings } = useUISettings();

const currentAccountId = useMapGetter('getCurrentAccountId');
const isFeatureEnabledonAccount = useMapGetter(
  'accounts/isFeatureEnabledonAccount'
);

const showCopilotTab = computed(() =>
  isFeatureEnabledonAccount.value(currentAccountId.value, FEATURE_FLAGS.CAPTAIN)
);

const { uiSettings } = useUISettings();
const isContactSidebarOpen = computed(
  () => uiSettings.value.is_contact_sidebar_open
);
const isCopilotPanelOpen = computed(
  () => uiSettings.value.is_copilot_panel_open
);

const toggleConversationSidebarToggle = () => {
  updateUISettings({
    is_contact_sidebar_open: !isContactSidebarOpen.value,
    is_copilot_panel_open: false,
  });
};

const handleConversationSidebarToggle = () => {
  updateUISettings({
    is_contact_sidebar_open: true,
    is_copilot_panel_open: false,
  });
};

const handleCopilotSidebarToggle = () => {
  updateUISettings({
    is_contact_sidebar_open: false,
    is_copilot_panel_open: true,
  });
};

const keyboardEvents = {
  'Alt+KeyO': {
    action: toggleConversationSidebarToggle,
  },
};
useKeyboardEvents(keyboardEvents);
</script>

<template>
  <ButtonGroup
    no-animation
    class="flex items-center rounded-lg bg-n-alpha-2 p-0.5"
  >
    <Button
      v-tooltip.bottom="$t('CONVERSATION_SIDEBAR.DETAILS')"
      ghost
      slate
      xs
      class="!h-7 !rounded-md !px-2 transition-colors"
      :class="{
        'bg-n-solid-1 shadow-sm': isContactSidebarOpen,
      }"
      icon="i-ph-user-bold"
      @click="handleConversationSidebarToggle"
    >
      <span
        class="text-xs font-medium"
        :class="rail ? 'inline' : 'hidden 2xl:inline'"
      >
        {{ $t('CONVERSATION_SIDEBAR.DETAILS') }}
      </span>
    </Button>
    <Button
      v-if="showCopilotTab"
      v-tooltip.bottom="$t('CONVERSATION.SIDEBAR.COPILOT')"
      ghost
      slate
      xs
      class="!h-7 !rounded-md !px-2 transition-colors"
      :class="{
        'bg-n-solid-1 !text-n-iris-9 shadow-sm': isCopilotPanelOpen,
      }"
      icon="i-woot-captain"
      @click="handleCopilotSidebarToggle"
    >
      <span
        class="text-xs font-medium"
        :class="rail ? 'inline' : 'hidden 2xl:inline'"
      >
        {{ $t('CONVERSATION.SIDEBAR.COPILOT') }}
      </span>
    </Button>
  </ButtonGroup>
</template>
